import React from 'react';
import { getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import { kebabCase, lowerCase } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimer } from '@fortawesome/pro-light-svg-icons';
import { StyledArticleMeta } from './styles';
import { Text } from '../Text/index';
import { Avatar, TSizes } from '../Avatar/index';
import { Badge } from '../Badge';

interface IArticleMeta {
  date: string;
  timeToRead: number;
  tags: string[];
  author: { name: string; image: any; slug: string };
  authorBig?: boolean;
  center?: boolean;
  className?: string;
  imageSize?: TSizes;
  allTags?: boolean;
  disableAvatarLink?: boolean;
}

export const ArticleMeta = ({
  author,
  authorBig = false,
  tags,
  date,
  timeToRead,
  center = false,
  imageSize = `xs`,
  className,
  allTags = false,
  disableAvatarLink = false,
}: IArticleMeta) => {
  const { name: authorName, image: authorImg, slug: authorSlug } = author;
  const autorImage = getImage(authorImg);

  return (
    <StyledArticleMeta
      center={center}
      className={className}
      authorBig={authorBig}
    >
      <div className="author">
        <Avatar
          disableLink={disableAvatarLink}
          alt={authorName}
          imageUrl={autorImage}
          size={imageSize}
          linkTo={`/about/${authorSlug}`}
        />
        <Text
          noRhythem
          className="author__name"
          type={authorBig ? `title3` : `body3`}
          tag="div"
          color="gray_3"
        >
          {authorName}
        </Text>
      </div>
      <div className="meta">
        <Text
          className="meta__text"
          noRhythem
          type="body3"
          tag="div"
          color="gray_3_65"
        >
          <div className="read-time">
            <FontAwesomeIcon
              size="1x"
              className="read-time__icon"
              icon={faTimer}
            />
            <div className="read-time__content">
              {timeToRead} min · {date}
            </div>
          </div>
        </Text>
        <div className="tags">
          {tags.map((tag: string, idx: number) => {
            if (allTags) {
              return (
                <Link
                  to={`/tags/${kebabCase(lowerCase(tag))}`}
                  key={tag}
                  className="tag"
                >
                  <Badge randomColor>{tag}</Badge>
                </Link>
              );
            }
            return idx > 1 ? null : (
              <Link
                to={`/tags/${kebabCase(lowerCase(tag))}`}
                key={tag}
                className="tag"
              >
                <Badge randomColor>{tag}</Badge>
              </Link>
            );
          })}
        </div>
      </div>
    </StyledArticleMeta>
  );
};
